import React from 'react'
import styled from 'styled-components'
import PeopleWidgetWithOutHolo from '../../common/components/PeopleWidgetWithOutHolo'
import { parseColorGradientMixture } from '../../../Utils/UtilityFunctions'
import { Radio } from 'antd'
import { AetnaHierarchyCompanyCard } from '../../../Types/CompaniesTypes'
import {
  maxTablet, primaryColor, maxWidth, retina, minWidthApp,
} from '../../../Utils/utilsStyle'

type Props = {
  company: AetnaHierarchyCompanyCard
  selected: boolean
  onSelect: () => void
};

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;

  .click-area {
    display: flex;
    align-items: center;
    gap: 12px;
    cursor: pointer;
    user-select: none;
    outline: none;
    width: 100%;
  }

  .ant-radio-wrapper {
    margin-right: 0;
    pointer-events: none;
  }

  .ant-radio-checked .ant-radio-inner {
    border-color: ${primaryColor};
    background-color: ${primaryColor};
  }

  .ant-radio:hover .ant-radio-inner {
    border-color: ${primaryColor};
  }

  .card {
    flex: 1;
    min-width: 0;
    min-height: 65px ;
    display: flex;
    flex-direction: row;
    align-items: center;
    box-sizing: border-box;
    padding: 15px 24px 16px 14px;
    border-radius: 10px;
    gap: 12px;
    border: 1px solid #DADADA;
    background: #FFF;
    box-shadow: 0 0 17px -2px rgba(0, 0, 0, 0.12);
    &:hover {
      border: 1px solid ${primaryColor};
    }
    // @media all and (max-width: ${maxWidth}), ${retina} {
    //   padding: 15px 24px 16px 14px;
    // }

    .smart-account-avatar-ring {
      flex: 0 0 auto;
      flex-shrink: 0;
      line-height: 0;
      width: 54px;
      height: 54px;
      min-width: 54px;
      border-radius: 50%;
      box-sizing: border-box;
      border: 3px solid transparent;
      background:
        linear-gradient(#fff, #fff) padding-box,
        conic-gradient(from -180deg, var(--smart-ring)) border-box;
      display: flex;
      align-items: stretch;
      justify-content: stretch;

      @media all and (max-width: ${maxWidth}) , ${retina} {
        width: 54px;
        height: 54px;
        min-width: 54px;
      }
      @media all and (max-width: ${minWidthApp}){
        width: 49px;
        height: 49px;
        min-width: 49px;
      }
    }

    /* Ensure the logo fits nicely inside the circle */
    .smart-account-avatar-ring .smart-account-logo {
      background-size: 85% 85% !important;
      background-repeat: no-repeat !important;
      background-position: center !important;
    }
    @media all and (max-width: ${maxTablet}) {
      height: 45px;
    }
    
    .company-name {
      color: #000;
      font-family: "Roboto Slab";
      font-size: 20px;
      font-style: normal;
      font-weight: 500;
      line-height: 24px; /* 120% */
      letter-spacing: -0.417px;
      margin-bottom: 0px;
      @media all and (max-width: ${maxWidth}), ${retina} {
        font-size: 18px;
      }
      @media all and (max-width: ${maxTablet}) {
        font-size: 16px;
        line-height: 20px;
      }
    }
  } 

  &.selected {
    .card {
      border-color: ${primaryColor};
      box-shadow: 0 0 2px ${primaryColor};
    }
  }

  @media all and (max-width: ${maxTablet}) {
    width: 100%;
  }
`

const SmartAccountCompanyCard = (props: Props) => {
  const { company, selected, onSelect } = props;
  const ringColor = parseColorGradientMixture(company?.companyPersonality);

  return (
    <Wrapper className={selected ? 'selected' : ''}>
      <div
        className="click-area"
        role="button"
        tabIndex={0}
        onClick={onSelect}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            onSelect();
          }
        }}
      >
        <Radio checked={selected} onChange={() => { /* controlled via parent onClick */ }} />
        <div className='card'>
          <div
            className="smart-account-avatar-ring"
            style={{ ['--smart-ring' as any]: ringColor }}
          >
            <PeopleWidgetWithOutHolo
              key={company?.companyId}
              diameter="100%"
              diameterSm="100%"
              diameterXsm="100%"
              margin="0"
              marginSm="0"
              wrapperColor="transparent"
              logo={company?.companyLogo}
              companyId={String(company?.companyId) !== '' ? company?.companyId : 0}
              ringPadding="0px"
              ringPaddingSm="0px"
              ringSize="contain"
              ringPosition="center"
              imageClassName="smart-account-logo"
              disableNavigation
            />
          </div>
          <p className='company-name'>{company?.companyName}</p>
        </div>
      </div>
    </Wrapper>
  )
}
export default SmartAccountCompanyCard;